<template>
    <div class="form-group filter-multiselect">
        <label :for="htmlFor">{{ title }}</label>
        <div 
            v-if="has !== null" 
            :class="filterStyle" 
            class="input-group filter-multiselect-with-modifier">
            <div class="input-group-btn">
                <button 
                    :class="buttonClass" 
                    type="button" 
                    class="btn dropdown-toggle"
                    data-toggle="dropdown" 
                    aria-expanded="false">
                    {{ buttonText }}
                    <span class="fa fa-caret-down"/>
                </button>
                <ul class="dropdown-menu">
                    <li><a 
                        href="#" 
                        @click.prevent="updateHasValue(1)">da</a></li>
                    <li><a 
                        href="#" 
                        @click.prevent="updateHasValue(-1)">ne</a></li>
                    <li class="divider"/>
                    <li><a 
                        href="#" 
                        @click.prevent="updateHasValue(0)">ponastavi</a></li>
                </ul>
            </div>
            <multiselect 
                :id="htmlFor"
                v-model="option"
                :options="options"
                :custom-label="label"
                :close-on-select="true"
                :disabled="hasValue !== 0"
                selected-label="Izbrano"
                select-label=""
                deselect-label="Odstrani"
                placeholder="Izberi"
                track-by="id"
                label="name"
                @input="submit"/>
        </div>
        <div 
            v-else 
            :class="filterStyle" 
            class="filter-multiselect-without-modifier">
            <multiselect 
                :id="htmlFor"
                v-model="option"
                :options="options"
                :custom-label="label"
                :close-on-select="true"
                selected-label="Izbrano"
                select-label=""
                deselect-label="Odstrani"
                placeholder="Izberi"
                track-by="id"
                label="name"
                @input="submit"/>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
    name: 'ContactSearchMultiselect',

    components: {
        Multiselect
    },

    props: {
        value:   {
            required: true
        },
        options: {
            required: true,
            type:     Array
        },
        has:     {
            required: false,
            default:  null
        },
        htmlFor: {
            required: true,
            type:     String
        },
        title:   {
            required: true,
            type:     String
        },
        label:   {
            required: false,
            type:     Function,
            default:  this.multiselectLabel,
        }
    },

    data() {
        return {
            option:   null,
            hasValue: this.has
        };
    },

    computed: {
        buttonText() {
            switch (Number(this.hasValue)) {
            case 1:
                return 'da';
            case 0:
                return 'da / ne';
            case -1:
                return 'ne';
            }
        },

        buttonClass() {
            switch (Number(this.hasValue)) {
            case 1:
                return 'btn-success';
            case 0:
                return 'btn-default';
            case -1:
                return 'btn-danger';
            }
        },

        filterStyle() {
            return this.value ? 'filter-active-multiselect' : '';
        }
    },

    watch: {
        value(current) {
            this.$set(this, 'option', current);
        },

        has(current) {
            this.$set(this, 'hasValue', current);
        }
    },

    created() {
        this.$set(this, 'option', this.value);
    },

    methods: {
        submit() {
            this.$emit('input', this.option);
            this.$parent.submit();
        },

        multiselectLabel(option) {
            return option.name;
        },

        updateHasValue(value) {
            this.$set(this, 'hasValue', value);
            this.$emit('update:has', value);
            this.$parent.submit();
        }
    }
};
</script>

<style>
    .multiselect {
        min-height: 36px;
        max-height: 36px;
    }

    .multiselect__tags {
        border-radius: 0;
        min-height: 36px;
        max-height: 36px;
        padding-top: 7px;
    }

    .multiselect__select {
        top: 0;
    }
</style>

<style scoped>
    .btn {
        border-radius: 0;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/Contacts/Components/Multiselect.vue